import Slider from './components/Slider';
import './App.css';
import Intro from './components/Intro';
import Nav from './components/Nav';
import Faq from './components/Faq';
import Outro from './components/Outro';
import Responsive from './components/Responsive';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Responsive></Responsive>
      
      <div className="app__main">
        <Nav></Nav>
        <Intro></Intro>
        <Slider />
        <Faq></Faq>
        <Outro></Outro>
        <Footer></Footer>
      </div>
    </div>
  );
}

export default App;
